var React = require('react');

function Screwdriver (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 0l64 64-96 128h-62.07l-83 83A98.45 98.45 0 0 0 237 241.09l83-83V96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M63.61 501.08l-52.7-52.7a37.28 37.28 0 0 1 0-52.71L128 278.59A74.54 74.54 0 0 1 233.4 384L116.32 501.08a37.26 37.26 0 0 1-52.71 0z","className":"fa-primary","key":2})]);
}

Screwdriver.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Screwdriver;

Screwdriver.default = Screwdriver;
